export { default } from "./ListMovimientosIngredientes";
